import React, { useState, useEffect } from "react";
import { Empty, AutoComplete } from "antd";
import Utils from "../../../../utility/Utils";
import SIFilter from "../SiFilter";
import { useReportsStore } from "../../ReportsStore";
import { useSearchParams } from "react-router-dom";
const { Option } = AutoComplete;

const SIwise = () => {
  const [siDetails, setSIDetails] = useState([]);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [options, setOptions] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const { siSerialNo, setSiSerialNo, siFirstRender, setSiFirstRender, tab } =
    useReportsStore();
  const fetchData = async () => {
    const optionsData = await SIFilter.getSIWiseReport();
    setOptions(optionsData);
  };
  const updateQueryParams = () => {
    setSearchParams({
      tab: tab,
      siName: siSerialNo,
    });
  };
  const fetchData2 = async (siSerialNo) => {
    if (siFirstRender) {
      let serialNo = searchParams.get("siName");
      if (serialNo?.length > 0) {
        setSiSerialNo(serialNo);
      }
      setSiFirstRender(false);
    }
    const nameParts = siSerialNo.split(" ");
    const first = nameParts[0];
    const last = nameParts[nameParts.length - 1];
    setFname(first);
    setLname(last);
    const sid = await SIFilter.getSearchbySNReport(fname, lname);
    setSIDetails(sid);
  };

  const handleOptionSelect = (value) => {
    setSiSerialNo(value);
    fetchData2(value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (siSerialNo) {
      fetchData2(siSerialNo);
    }
  }, [siSerialNo]);
  useEffect(() => {
    if (!siFirstRender) {
      updateQueryParams();
    }
  }, [siSerialNo]);
  return (
    <>
      <div className="search-filter mb-3">
        <AutoComplete
          className="col-12 col-sm-6 col-lg-3"
          placeholder="Search by SI Name"
          value={siSerialNo}
          onChange={(value) => {
            setSiSerialNo(value);
          }}
          onSearch={fetchData}
          onSelect={handleOptionSelect}
        >
          {options.map((option) => (
            <Option
              key={option._id.firstname + option._id.lastname}
              value={`${option._id.firstname} ${option._id.lastname}`}
            >
              {`${option._id.firstname} ${option._id.lastname}`}
            </Option>
          ))}
        </AutoComplete>
      </div>

      {siDetails[0] ? (
        <>
          <div className="info-container border rounded-3 bg-light mb-4">
            <div className="card-heading m-2">SI Details</div>
            <div className="info-container border-none rounded-3 bg-white p-3">
              <div className="d-flex flex-md-row flex-column border-none  ">
                <div className="col-sm d-flex justify-content-center w-100 p-3">
                  <div className="w-50">
                    <b>SI Name</b>
                  </div>
                  <div className="w-50">
                    {siDetails[0].si_details.firstname === "NA" &&
                    siDetails[0].si_details.lastname === "NA"
                      ? "NA"
                      : `${siDetails[0].si_details.firstname} ${siDetails[0].si_details.lastname}`}
                  </div>
                </div>
                <div className="col-sm d-flex justify-content-center w-100 p-3">
                  <div className="w-50">
                    <b>Contact</b>
                  </div>
                  <div className="w-50">
                    {siDetails[0].si_contact_details
                      ? siDetails[0].si_contact_details[0].contact
                      : "NA"}
                  </div>
                </div>
              </div>
              <div className="d-flex flex-md-row flex-column border-none ">
                <div className="col-sm d-flex justify-content-center w-100 p-3">
                  <div className="w-50">
                    <b>Address</b>
                  </div>
                  <div className="w-50">
                    {siDetails[0].si_contact_address_details
                      ? siDetails[0].si_contact_address_details[0].address
                      : "NA"}
                  </div>
                </div>
                <div className="col-sm d-flex justify-content-center w-100 p-3">
                  <div className="w-50">
                    <b>City</b>
                  </div>
                  <div className="w-50">
                    {siDetails[0].si_contact_address_details
                      ? siDetails[0].si_contact_address_details[0].city
                      : "NA"}
                  </div>
                </div>
              </div>
              <div className="d-flex flex-md-row flex-column border-none ">
                <div className="col-sm d-flex justify-content-center w-100 p-3">
                  <div className="w-50">
                    <b>Country</b>
                  </div>
                  <div className="w-50">
                    {siDetails[0].si_contact_address_details
                      ? siDetails[0].si_contact_address_details[0].country
                      : "NA"}
                  </div>
                </div>
                <div className="col-sm d-flex justify-content-center w-100 p-3">
                  <div className="w-50">
                    <b>Pin</b>
                  </div>
                  <div className="w-50">
                    {siDetails[0].si_contact_address_details
                      ? siDetails[0].si_contact_address_details[0].zip
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <p></p>
      )}

      {siDetails ? (
        siDetails.map((item, index) => (
          <>
            <div className="info-container border rounded-3 bg-light mb-4">
              <div className="card-heading m-2">Gateway Details</div>
              <div className="info-container border-none rounded-3 bg-white p-3">
                <div className="d-flex flex-md-row flex-column border-none  ">
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Serialnumber</b>
                    </div>
                    <div className="w-50">{item.gateway_serial_number}</div>
                  </div>
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Customer Name</b>
                    </div>
                    <div className="w-50">
                      {item.customer_details.firstname === "NA" &&
                      item.customer_details.lastname === "NA"
                        ? "NA"
                        : `${item.customer_details.firstname} ${item.customer_details.lastname}`}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-md-row flex-column border-none ">
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Installation Time</b>
                    </div>
                    <div className="w-50">
                      {Utils.istTime(item.start_time)} -
                      {Utils.istTime(item.end_time)}
                    </div>
                  </div>
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Customer Contact</b>
                    </div>
                    <div className="w-50">
                      {item.customer_contact_details
                        ? item.customer_contact_details[0].contact
                        : "NA"}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-md-row flex-column border-none ">
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Installation Duration</b>
                    </div>
                    <div className="w-50">
                      {Math.floor(item.total_hours * 100) / 100} hours
                    </div>
                  </div>
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Customer Address</b>
                    </div>
                    <div className="w-50">
                      {item.customer_contact_address_details
                        ? item.customer_contact_address_details[0].address
                        : "NA"}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-md-row flex-column border-none ">
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Installation Status</b>
                    </div>
                    <div className="w-50">{item.status}</div>
                  </div>
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b></b>
                    </div>
                    <div className="w-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ))
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </>
  );
};

export default SIwise;
